import axios from "axios";
// import { request } from "https";

export const BASE_URL = "http://riskapp.local";

export const client = axios.create({
  baseURL: BASE_URL,
  useCredentials: true,
});

client.interceptors.request.use((req) => {
  // var access_token = Cookies.get("lika-Portal");
  var access_token = sessionStorage.getItem("risk-app");
  req.headers = {
    ...req.headers,
    Authorization: `Bearer ${access_token}`,
  };
  // Important: request interceptors **must** return the request.
  return req;
});
